module.exports = __webpack_public_path__ + "img/scm-square.30a3de7c.png";